import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Images } from 'assets/images';
import { LoadingButton } from 'components';
import { ImageLazy } from 'components/ImageLazy';
import { LazyContainer } from 'components/ImageLazy/styled';
import { useFindError } from 'hooks/useFindError';
import { useFindLoad } from 'hooks/useFindLoad';
import { useFindSuccess } from 'hooks/useFindSuccess';
import { authActions, httpRequestsOnErrorsActions } from 'store';
import { EMAIL_VERIFY, PASSWORD_RECOVERY_EMAIL_VERIFY } from 'store/auth';
import { ROUTES } from 'utils/routeNames';
import { getStorage, removeStorage } from 'utils/storageHelpers';
import {
  BoldResendText,
  CloseIcon,
  CloseIconLink,
  ErrorMessage,
  ForgotPasswordBlock,
  ForgotPasswordWrapper,
  Form,
  InputBlocksForVerification,
  ModalDescription,
  OtpFieldWrapper,
  PageTitle,
  StyledButtonContainer,
} from './styled';

const VerifyPassword = () => {
  const navigate = useNavigate();
  const inputLength = 4;

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const codeError = useFindError(EMAIL_VERIFY);

  const codeErrorForRecovery = useFindError(PASSWORD_RECOVERY_EMAIL_VERIFY);

  const codeSuccess = useFindSuccess(EMAIL_VERIFY);

  const isLoading = useFindLoad(EMAIL_VERIFY);

  const isLoadingForgotPassword = useFindLoad(PASSWORD_RECOVERY_EMAIL_VERIFY);

  const forgotPasswordSuccess = useFindSuccess(PASSWORD_RECOVERY_EMAIL_VERIFY);

  const [otp, setOtp] = useState('');
  const [error, setError] = useState({});

  const accessToken = useSelector((state) => state.auth.accessToken);

  const changeCodeInputs = (value) => {
    setOtp(value);
    if (otp.length < inputLength) {
      setError({});
    }
  };

  const submit = (e) => {
    e.preventDefault();
    if (otp.length < inputLength) {
      setError({ code: t('verificaionCodeError') });
    } else if (getStorage('email')) {
      dispatch(
        authActions.emailVerify({ code: parseInt(otp), email: getStorage('email') }),
      );
    } else if (getStorage('verify_email')) {
      dispatch(
        authActions.sendCodeRecoveryPassword({
          code: parseInt(otp),
          email: getStorage('verify_email'),
        }),
      );
    }
  };

  useEffect(() => {
    if (codeErrorForRecovery.length || codeError.length) {
      setError({ code: t('invalidCode') });
    }
  }, [codeErrorForRecovery.length, codeError.length]);

  useEffect(() => {
    if (codeSuccess.length) {
      setTimeout(() => {
        if (accessToken) {
          removeStorage('fbAccessToken');
          navigate(ROUTES.HOME);
        } else {
          navigate(ROUTES.LOGIN);
        }
      }, 3000);
    }

    if (forgotPasswordSuccess.length) {
      navigate(ROUTES.NEW_PASSWORD);
    }
  }, [codeSuccess.length, accessToken, forgotPasswordSuccess.length]);

  useEffect(
    () => () => {
      dispatch(httpRequestsOnErrorsActions.removeError(EMAIL_VERIFY));
      dispatch(
        httpRequestsOnErrorsActions.removeError(PASSWORD_RECOVERY_EMAIL_VERIFY),
      );
    },
    [],
  );

  return (
    <ForgotPasswordWrapper>
      <LazyContainer>
        <ImageLazy
          src={Images.loginMainBackground}
          width="100%"
          height="100%"
          hash="LqBE%hJDxWWBX=xaaxa}x^awWYof"
        />
      </LazyContainer>
      <ForgotPasswordBlock>
        <Form onSubmit={submit}>
          <PageTitle>Verification</PageTitle>
          <CloseIconLink to={ROUTES.LOGIN} onClick={() => removeStorage('email')}>
            <CloseIcon src={Images.closeBlueIcon} />
          </CloseIconLink>
          <ModalDescription>
            Please, enter the verification code sent to the email address you
            mentioned previously.
          </ModalDescription>
          <InputBlocksForVerification>
            <OtpFieldWrapper
              value={otp}
              onChange={changeCodeInputs}
              numInputs={inputLength}
              onChangeRegex={/^([0-9]{0,})$/}
              autoFocus
              isInputNum={true}
              error={error?.code}
              inputStyle={'otp-field__input'}
            />
          </InputBlocksForVerification>
          <ErrorMessage>{error?.code ?? null}</ErrorMessage>
          <ModalDescription isTextLeft>
            If you didn`t receive code<BoldResendText>Resend</BoldResendText>
          </ModalDescription>
          <StyledButtonContainer>
            <LoadingButton
              width="100%"
              height="54px"
              fs="20px"
              loading={isLoading || isLoadingForgotPassword}
              name="Verify"
              type="submit"
            />
          </StyledButtonContainer>
        </Form>
      </ForgotPasswordBlock>
    </ForgotPasswordWrapper>
  );
};

export default VerifyPassword;
